jQuery(document).foundation();

/** Flatpickr date picker **/
var eighteenYearsAgo = new Date();
eighteenYearsAgo.setYear(eighteenYearsAgo.getFullYear() - 18);
jQuery('.__date_filtered').flatpickr({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "F j, Y",
  maxDate: eighteenYearsAgo,
});
jQuery('.__date').flatpickr({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "F j, Y",
});

document.addEventListener( 'wpcf7submit', function( event ) {
  jQuery('.__date_filtered').flatpickr({
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "F j, Y",
    maxDate: eighteenYearsAgo,
  });
  jQuery('.__date').flatpickr({
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "F j, Y",
  });
}, false );